import { PublicClientApplication, Configuration } from "@azure/msal-browser";
import { authService } from "@/modules/auth/services/auth.service";
import { getEnv } from "@/core/env";

const msalConfig: Configuration = {
  auth: {
    clientId: getEnv("VUE_APP_MICROSOFT_CLIENT_ID", "dummy-client-id"),
    authority: `https://login.microsoftonline.com/${getEnv(
      "VUE_APP_MICROSOFT_TENANT_ID",
      "common"
    )}`,
    redirectUri: window.location.origin, // Puede ser / o la misma página de login
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Es necesario inicializar la instancia de forma global para que el popup se pueda cerrar
export const bootMsal = async () => {
  try {
    await msalInstance.initialize();
    // handleRedirectPromise procesará el hash si venimos de un redirect de Microsoft
    const response = await msalInstance.handleRedirectPromise();

    if (response && response.idToken) {
      console.log(
        "Redirección de Microsoft completada. Enviando al backend..."
      );
      const serverResponse = await authService.microsoftAuth({
        idToken: response.idToken,
        invitationCode:
          sessionStorage.getItem("msal_invitation_code") || undefined,
        action:
          (sessionStorage.getItem("msal_action") as "LOGIN" | "REGISTER") ||
          "LOGIN",
      });
      sessionStorage.removeItem("msal_invitation_code");
      sessionStorage.removeItem("msal_action");

      const hasCompany = serverResponse.hasCompany;
      const roles = serverResponse.roles || [];

      if (hasCompany === false && roles.includes("ADMIN")) {
        window.location.href = "/register?step=company-setup";
      } else {
        window.location.href = "/dashboard";
      }
    }
  } catch (error) {
    console.error("Error al inicializar MSAL:", error);
  }
};
